$.fn.extend({
    animateCss(animationName, ...args) {
        const animationEnd = 'animationend oAnimationEnd mozAnimationEnd webkitAnimationEnd MSAnimationEnd';
        let removeClass = false;
        let cb = null;

        if (typeof args[0] === 'boolean') {
            removeClass = args[0];
            cb = args[1];
        } else {
            cb = args[0];
        }

        this.addClass(`animated ${animationName}`).one(animationEnd, () => {
            if (removeClass) {
                $(this).removeClass(`animated ${animationName}`);
            }

            if (typeof cb === 'function') cb();
        });

        return this;
    },
});



// WEBPACK FOOTER //
// ./frontend/js/animation.js